import { z } from "zod";

/**
 * The constraint familiarity scale is fixed at five rungs. Rungs are never
 * added or removed — only their names and definitions are editable, which is
 * the same posture already taken on the performance scale.
 */
// Not exported: knip fails the commit on an exported-but-unused symbol, and
// nothing outside this file needs it until the profile rating control lands.
const CONSTRAINT_SCALE_ORDINAL_MAX = 5;

/**
 * Payload for renaming or redefining one rung (Settings → Config → Constraint
 * ratings). A blank definition clears it.
 *
 * Editing these never rewrites a recorded rating: `person_constraint` stores
 * the ordinal, so the number someone was given survives any rewording.
 */
export const constraintLevelUpdateSchema = z.object({
  ordinal: z.number().int().min(1).max(CONSTRAINT_SCALE_ORDINAL_MAX),
  name: z.string().trim().min(1, "Name is required").max(200),
  description: z.string().trim().max(2000).nullable(),
});

export type ConstraintLevelUpdateInput = z.infer<typeof constraintLevelUpdateSchema>;
